import React from 'react';
import {faCircleExclamation} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function Section({title, children, className, comment, addElement}) {

    return (
        <section className={`page-break detail-section ${className ?? ""}`}>
            <div className="text-[12px] bold detail-section-head">
                {title &&
                    <>
                        <span className="detail-section-pill ">
                            <span className="section-title detail-section-title">{title}</span>
                        </span>
                        {addElement && <div className="ml-2 align-middle inline-block detail-section-extra">{addElement}</div>}
                    </>

                }

                {
                    comment && (
                        <abbr title={comment} className="detail-section-comment">
                            <FontAwesomeIcon icon={faCircleExclamation} className={"ml-2 text-[14px]"} />
                        </abbr>
                    )
                }
            </div>
            {children}
        </section>
    );
}

export default Section;
